import { fetchJourneyDebug, adminJourneyRecompute } from "./sacred-journey-api";

/**
 * Browser console: await testJourney("user@example.com")
 */
export async function testJourney(email) {
  if (!email) {
    console.warn("[testJourney] Usage: await testJourney('user@example.com')");
    return null;
  }

  console.group(`[testJourney] ${email}`);

  try {
    const debug = await fetchJourneyDebug(email);
    console.log("debug report:", debug);
    console.log("mapping inputs:", debug.mapping_inputs);
    console.log("computed outputs:", debug.computed_outputs);
    console.log("daily guidance:", debug.computed_outputs?.daily_guidance);
    console.log("compute log:", debug.compute_log);
  } catch (e) {
    console.error("debug failed:", e?.response?.data?.detail || e.message);
  }

  try {
    const journey = await adminJourneyRecompute(email);
    console.log("recomputed journey:", journey);
  } catch (e) {
    console.warn("recompute (admin):", e?.response?.data?.detail || e.message);
  }

  console.groupEnd();
  return { email };
}

export function installJourneyTestConsole() {
  if (typeof window !== "undefined") {
    window.testJourney = testJourney;
  }
}
